/**
 * Data colours, separate from brand chrome. Validated with the dataviz
 * validator against the Console surfaces (#ffffff light, #171a20 dark):
 * every adjacent pair clears CVD ΔE ≥ 8.4 and normal-vision ΔE ≥ 19.8.
 * Aqua and yellow sit below 3:1 on white, so token charts always ship a
 * legend and a table view (the "relief rule").
 *
 * Order is the safety mechanism — assign slots in this order, never cycle.
 */
export const SERIES = {
  blue: "var(--series-1)",
  orange: "var(--series-2)",
  aqua: "var(--series-3)",
  yellow: "var(--series-4)",
} as const;

/** Token types always wear the same slot, on every chart and every project. */
export const TOKEN_SERIES = [
  { key: "inputTokens", label: "Input", color: SERIES.blue },
  { key: "outputTokens", label: "Output", color: SERIES.orange },
  { key: "cacheReadTokens", label: "Cache read", color: SERIES.aqua },
  { key: "cacheWriteTokens", label: "Cache write", color: SERIES.yellow },
] as const;
